<script>
import Draggable from 'vuedraggable';
import MacroNode from './MacroNode.vue';
import { getFileName } from './macroHelper';

export default {
  components: {
    Draggable,
    MacroNode,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'resetAction', 'deleteNode', 'addNewNode'],
  computed: {
    actionData: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    fileName() {
      return getFileName(...arguments);
    },
  },
};
</script>

<template>
  <div class="macros__nodes">
    <div class="macro__node">
      <div>
        <span
          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-n-violet-3 text-n-violet-11 text-label-small uppercase tracking-wider"
        >
          <span class="rounded-full size-1.5 bg-n-brand-violet" />
          {{ $t('MACROS.EDITOR.START_FLOW') }}
        </span>
      </div>
    </div>
    <Draggable
      :list="actionData"
      animation="200"
      item-key="id"
      ghost-class="ghost"
      tag="div"
      class="macros__nodes-draggable"
      handle=".macros__node-drag-handle"
    >
      <template #item="{ index: i }">
        <div :key="i" class="macro__node">
          <MacroNode
            v-model="actionData[i]"
            class="macros__node-action"
            type="add"
            :index="i"
            :error-key="errors[`action_${i}`]"
            :file-name="
              fileName(
                actionData[i].action_params[0],
                actionData[i].action_name,
                files
              )
            "
            :single-node="actionData.length === 1"
            @reset-action="$emit('resetAction', i)"
            @delete-node="$emit('deleteNode', i)"
          />
        </div>
      </template>
    </Draggable>
    <div class="macro__node">
      <div>
        <button
          type="button"
          :title="$t('MACROS.EDITOR.ADD_BTN_TOOLTIP')"
          class="flex items-center justify-center w-full h-11 gap-2 text-sm font-medium transition-colors border-2 border-dashed rounded-xl border-n-weak dark:border-n-strong bg-n-solid-1/60 text-n-slate-11 hover:border-n-brand-violet hover:text-n-violet-11 max-w-[36rem]"
          @click="$emit('addNewNode')"
        >
          <span class="i-lucide-plus size-4" />
          {{ $t('MACROS.EDITOR.ADD_BTN_TOOLTIP') }}
        </button>
      </div>
    </div>
    <div class="macro__node">
      <div>
        <span
          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-n-violet-3 text-n-violet-11 text-label-small uppercase tracking-wider"
        >
          <span class="rounded-full size-1.5 bg-n-brand-violet" />
          {{ $t('MACROS.EDITOR.END_FLOW') }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.macros__nodes {
  max-width: 800px;
}

.macro__node:not(:last-child) {
  position: relative;
  padding-bottom: 2rem;
}

.macro__node:not(:last-child):not(.sortable-chosen):after,
.macros__nodes-draggable:after {
  @apply border-l-2 border-solid border-n-violet-7 dark:border-n-violet-9 ltr:ml-6 rtl:mr-6 absolute h-8 w-1 content-[""];
}

.macros__nodes-draggable {
  position: relative;
  padding-bottom: 2rem;
}
</style>
